import spritemap from "@milestone-sys/web-design-system/msds-spritemap.svg"
import "./row-action.scss"

export const AddRowAction = ({    
    row,    
    addClickHandler, 
}) => {
    return (
        <button id={"xsd__e2e-table-actions-add-camera-stream-row-" + row.Index} className="row-action" type="button" onClick={() => addClickHandler(row.original.cameraGroupId)} title="Add">
            <svg className="msds-icon">
                <use href={`${spritemap}#plus`} />
            </svg>
        </button>
    )
}

